import React, { Component } from 'react';

const WinnerStar = (props) => {
	const icon_size = 60;
	const padding = 16;

	const view_box = [-padding, -padding, icon_size + 2 * padding, icon_size + 2 * padding];

	return (
		<span class="winner_icon">
			<svg xmlns="http://www.w3.org/2000/svg" height="80%" viewBox={view_box.join(" ")}>
				<g class="winner_star">
					<circle class="bg" cx={icon_size / 2} cy={icon_size / 2} r={icon_size / 2} />
					<path class="star" d="M53.82,22.28c-0.39-1.2-1.39-2.1-2.63-2.37l-11.89-2.65L33.09,6.87C32.44,5.79,31.27,5.12,30,5.12c-1.27,0-2.44,0.66-3.09,1.74l-6.22,10.38L8.8,19.91c-1.24,0.28-2.24,1.18-2.63,2.37s-0.12,2.51,0.72,3.45l8.04,9.07l-1.13,12.03c-0.12,1.25,0.44,2.47,1.47,3.21c1.03,0.74,2.37,0.89,3.54,0.39L30,45.65l11.19,4.78c0.46,0.19,0.94,0.29,1.42,0.29c0.75,0,1.49-0.23,2.11-0.68c1.03-0.74,1.58-1.96,1.47-3.21l-1.13-12.03l8.04-9.07C53.94,24.79,54.22,23.48,53.82,22.28z" />
				</g>
			</svg>
		</span>
	)
};

export default WinnerStar;